/**************  CSS  **************/
import './Speed.css'

/**********  React hooks  **********/
import { useState, useRef, useEffect } from 'react'
import { useWakeLock } from 'react-screen-wake-lock'

/**********  Components  ***********/

/************  Others  *************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Localisation from '../../Assets/Localisation/Localisation';
import { WarningMessage } from '../../Assets/Messages/Messages';

function SpeedValue({speed, unit}) {
    return <p className='tda-Speed'>
        <span>{speed}</span><span>{unit}</span>
    </p>
}

export default function Speed() {
    /***********************************/
    /* Hooks                           */
    /***********************************/
    const { isSupported: wlIsSupported, request: wlRequest, release: wlRelease } = useWakeLock({
        reacquireOnPageVisible: true,
    });
    /***********  Callbacks  ***********/
    

    /*************  Refs  **************/

    
    /************  States  *************/
    const [currentLocalisation, setCurrentLocalisation] = useState({latitude: 0, longitude: 0, accuracy: 0})
    const [showAccuracy, setShowAccuracy] = useState(false)
    
    /******  Refs which need state  ******/
    const localisation = useRef(new Localisation(setCurrentLocalisation))

    /************  Memos  **************/
    
    
    /***********  Callbacks  ***********/

    
    /************  Effects  ************/
    useEffect(() => {
        wlRequest()
        localisation.current.activate(100)
        return () => {
            wlRelease()
            localisation.current.deactivate()
        }
    }, [wlRequest, wlRelease])

    const buttonShowAccuracy = e => {
        e.preventDefault()
        setShowAccuracy(!showAccuracy)
    }

    return <div onDoubleClick={buttonShowAccuracy}>
        <h1>Compteur vitesse</h1>
        {!wlIsSupported ? <center><FontAwesomeIcon icon="fa-solid fa-circle-info" /> Wake lock pas supporté</center> : false}
        {isNaN(currentLocalisation.speed) ? false : <SpeedValue speed={(currentLocalisation.speed * 3.6).toFixed(0)} unit='km/h' />}
        {showAccuracy ? <center>Current accuracy: <i>{currentLocalisation.accuracy.toFixed(1)}m</i></center> : false}
    </div>
}